import {
    CUSTOM_TRANSFORMATION_ERRORS_TYPE,
    ERROR_IN_REFERENCE_TYPE
} from 'app/store/__generated__/types';

export const CUSTOM_TRANSFORMATION_ERRORS = CUSTOM_TRANSFORMATION_ERRORS_TYPE.split('.').pop();
export const ERROR_IN_REFERENCE = ERROR_IN_REFERENCE_TYPE.split('.').pop();
